import React, { Component } from 'react'
import axios from 'axios';
import moment from 'moment';
import Layout from './Layout';
import { Button, Input, Breadcrumb, message, Switch, DatePicker } from 'antd';
import { adminRoutes } from '../helpers/adminRoutes';
import { getHeaderWithToken } from '../helpers/func';
import { SERVER_URL } from '../api';
import SproutsItemPicker from './SproutsItemPicker';

const { TextArea } = Input;

class AddSproutsRound extends Component {

    constructor(props) {
        super(props)
        this.state = {
            round_label: '',
            enabled: false,
            deadline: null, // moment
            title: '',
            subtitle: '',
            body: '',
            show_included_kit_image: true,
            items: [], // [{variantId, supplyId, name, price, image, categoryId}]
            saving: false,
            loading: !!this.getIdFromRoute(props),
        }
    }

    componentDidMount() {
        this.loadFromRoute();
    }

    // AdminRouter's wrapper Route doesn't forward the outer path pattern, so
    // `match.params` is always empty here — same issue AddSupply.jsx works
    // around by reading the id straight out of the URL instead. Also handles
    // AdminRouter reusing this mounted instance across /edit.../:id ->
    // /edit.../:otherId navigation (no remount), same as AddSupply.jsx.
    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.loadFromRoute();
        }
    }

    getIdFromRoute = (props) => {
        let location = (props || this.props).location;
        let path = location.pathname.split('/');
        return path[2] || null;
    }

    loadFromRoute = () => {
        let id = this.getIdFromRoute();
        if (id) this.load(id);
    }

    load = (id) => {
        axios({
            method: 'GET',
            url: `${SERVER_URL}v1/sprouts-round/${id}`,
            headers: getHeaderWithToken(),
        }).then((response) => {
            let round = response.data.data;
            let resolvedItems = response.data.resolvedItems || [];
            this.setState({
                round_label: round.round_label || '',
                enabled: !!round.enabled,
                deadline: round.deadline ? moment(round.deadline) : null,
                title: round.title || '',
                subtitle: round.subtitle || '',
                body: round.body || '',
                show_included_kit_image: round.show_included_kit_image !== false,
                items: resolvedItems,
                loading: false,
            });
        }).catch(() => {
            this.setState({ loading: false });
            message.error('Failed to load round.');
        });
    }

    save = () => {
        let { round_label, enabled, deadline, title, subtitle, body, show_included_kit_image, items } = this.state;

        if (!round_label || !round_label.trim()) {
            message.error('Round label is required.');
            return;
        }

        this.setState({ saving: true });

        let id = this.getIdFromRoute();
        let data = {
            round_label,
            enabled,
            deadline: deadline ? deadline.toISOString() : '',
            title,
            subtitle,
            body,
            show_included_kit_image,
            item_variant_ids: JSON.stringify(items.map(i => i.variantId)),
        };

        axios({
            method: id ? 'PUT' : 'POST',
            url: id ? `${SERVER_URL}v1/sprouts-round/${id}` : `${SERVER_URL}v1/sprouts-round`,
            headers: getHeaderWithToken(),
            data,
        }).then(() => {
            message.success('Round saved.');
            this.props.history.push(adminRoutes.SPROUTSROUNDLIST);
        }).catch((error) => {
            this.setState({ saving: false });
            let msg = (error.response && error.response.data && error.response.data.message) || 'Failed to save round.';
            message.error(msg);
        });
    }

    render() {
        let { round_label, enabled, deadline, title, subtitle, body, show_included_kit_image, items, saving, loading } = this.state;
        let isEdit = !!this.getIdFromRoute();

        return (
            <Layout>
                <div className="content-box supplies-page">
                    <div className="bredcrumb-div">
                        <Breadcrumb separator="-">
                            <Breadcrumb.Item><span>Sprouts Rounds</span></Breadcrumb.Item>
                            <Breadcrumb.Item><span>{isEdit ? 'Edit Round' : 'Add Round'}</span></Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="page-title d-flex">
                        <h2>{isEdit ? 'Edit Sprouts Round' : 'Add Sprouts Round'}</h2>
                        <Button onClick={this.save} type="primary" className="primary-btn" disabled={loading || saving} loading={saving} style={{ minWidth: 170 }}>
                            Save
                        </Button>
                    </div>
                    <div className="page-content">
                        <label>Round label</label>
                        <Input
                            value={round_label}
                            onChange={(e) => this.setState({ round_label: e.target.value })}
                            placeholder="e.g. August Sprouts 2026"
                        />

                        <div style={{ marginTop: 16 }}>
                            <label style={{ marginRight: 8 }}>Enabled (live to subscribers)</label>
                            <Switch checked={enabled} onChange={(val) => this.setState({ enabled: val })} />
                        </div>

                        <div style={{ marginTop: 16 }}>
                            <label>Selection deadline</label><br />
                            <DatePicker
                                showTime
                                value={deadline}
                                onChange={(val) => this.setState({ deadline: val })}
                                style={{ width: 260 }}
                            />
                        </div>

                        <div style={{ marginTop: 16 }}>
                            <label>Title</label>
                            <Input value={title} onChange={(e) => this.setState({ title: e.target.value })} placeholder="Sprouts Kits are Shipping Soon!" />
                        </div>

                        <div style={{ marginTop: 16 }}>
                            <label>Subtitle</label>
                            <Input value={subtitle} onChange={(e) => this.setState({ subtitle: e.target.value })} />
                        </div>

                        <div style={{ marginTop: 16 }}>
                            <label>Body</label>
                            <TextArea value={body} onChange={(e) => this.setState({ body: e.target.value })} autoSize={{ minRows: 3 }} />
                        </div>

                        <div style={{ marginTop: 16 }}>
                            <label style={{ marginRight: 8 }}>Show included-kit photo when there's nothing to choose</label>
                            <Switch checked={show_included_kit_image} onChange={(val) => this.setState({ show_included_kit_image: val })} />
                            <p className="note" style={{ fontSize: 13, color: '#8a989f', marginTop: 4 }}>
                                Only affects a round with exactly one yarn item (nothing to actively pick) — controls whether that item's photo shows or stays hidden. Doesn't affect add-on photos, or yarn photos when there's a real color choice.
                            </p>
                        </div>

                        <div style={{ marginTop: 24 }}>
                            <label>This round's items (yarn colors + add-ons, mixed — split automatically by Supply category)</label>
                            <SproutsItemPicker
                                value={items}
                                onChange={(val) => this.setState({ items: val })}
                            />
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}

export default AddSproutsRound;
